import { z } from 'zod';

/**
 * Mandanten-Terminanfrage (LegalTransactionMeetingRequest), interne Sicht.
 * Feldnamen entsprechen der API-Antwort von
 * GET /api/legaltransaction/{id}/meetingrequests.
 */
export const MEETING_REQUEST_STATUS = {
  REQUESTED: 10,
  ACCEPTED: 20,
  REJECTED: 30,
  COUNTER_PROPOSED: 40,
  CANCELLED: 50,
  EXPIRED: 60,
} as const;

export type MeetingRequestStatus =
  (typeof MEETING_REQUEST_STATUS)[keyof typeof MEETING_REQUEST_STATUS];

export const meetingRequestSchema = z
  .object({
    idLegalTransactionMeetingRequest: z.number(),
    idLegalTransaction: z.number(),
    idLegalClient: z.number().nullable().optional(),
    idMeetingType: z.number().nullable().optional(),
    // Relations-FKs kommen als Alias-Keys aus der generischen API.
    idLocation: z.number().nullable().optional(),
    idRoom: z.number().nullable().optional(),
    idUserCalendarConnection: z.number().nullable().optional(),
    RequestedStart: z.string().nullable().optional(),
    DurationInMin: z.number().nullable().optional(),
    Status: z.number(),
    CounterProposalStart: z.string().nullable().optional(),
    StaffMessage: z.string().nullable().optional(),
    ClientMessage: z.string().nullable().optional(),
    Decided_at: z.string().nullable().optional(),
    Created_at: z.string().nullable().optional(),
    Updated_at: z.string().nullable().optional(),
  })
  .passthrough();

export type IMeetingRequest = z.infer<typeof meetingRequestSchema>;

export const meetingRequestsResponseSchema = z.object({
  requests: z.array(meetingRequestSchema),
});

export type IMeetingRequestsResponse = z.infer<
  typeof meetingRequestsResponseSchema
>;
